import { render, staticRenderFns } from "./related-prompts-overview.view.vue?vue&type=template&id=3b7a4895&scoped=true"
import script from "./related-prompts-overview.view.vue?vue&type=script&lang=ts"
export * from "./related-prompts-overview.view.vue?vue&type=script&lang=ts"
import style0 from "./related-prompts-overview.view.vue?vue&type=style&index=0&id=3b7a4895&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7a4895",
  null
  
)

export default component.exports